var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class FrontPage extends Component {
    constructor() {
        super('FrontPage', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $(window).on('resize', () => {
                this.computeHeight();
            });
            setTimeout(() => {
                this.computeHeight();
            }, 100);
            if ($('body').hasClass('home')) {
                const backgroundClasses = ['bg-yellow', 'bg-red', 'bg-green'];
                $('body').addClass(backgroundClasses[Math.floor(Math.random() * backgroundClasses.length)]);
            }
            this.success();
        });
    }
    computeHeight() {
        const lastImage = $('#grid-layout-image-12');
        const gridLayout = $('.grid-layout');
        const bottom = lastImage.position(gridLayout).y + lastImage.height();
        const marginBottom = $(window).width() < 992 ? 0 : 50;
        gridLayout.css('min-height', bottom + marginBottom);
    }
}
